import React from "react"
import styled from "styled-components"

export default function signUpBackground() {
  return (
    <Wrapper>
      <div className="wave1">
        <Image src="../PM/pink-layers.svg" />
      </div>
      <div className="wave2" />
      <div className="wave3" />
    </Wrapper>
  )
}

const Wrapper = styled.div``

const Image = styled.img``
